import EditIcon from '@/src/assets/svgs/EditIcon'
import { TravelClassType } from '@/src/constants/travelers'
import { TranslationFunction } from '@/src/types/translations'
import { ArrowBack, ArrowForward, SwapHoriz } from '@mui/icons-material'
import CircleIcon from '@mui/icons-material/Circle'
import { Box, IconButton, Typography, useTheme } from '@mui/material'
import React from 'react'

export type SrpHeaderProps = {
    from: string
    to: string
    departDate: string
    returnDate: string
    travelers: string
    travelClass: TravelClassType
    onBackClick?: (isReloadRequired: boolean) => void
    onEditClick: () => void
    t: TranslationFunction<'common'>
}

const SrpHeader: React.FC<SrpHeaderProps> = ({
    from,
    to,
    departDate,
    returnDate,
    travelers,
    travelClass,
    onBackClick,
    onEditClick,
    t
}) => {
    const theme = useTheme()
    const isRtl = theme.direction === 'rtl'
    return (
        <Box
            sx={{
                width: '100%',
                bgcolor: 'background.paper',
                borderBottom: '1px solid',
                borderColor: 'grey.200',
                px: 2,
                py: 1.25,
                position: 'sticky',
                top: 0,
                zIndex: 1000
            }}
        >
            <IconButton
                onClick={() => onBackClick?.(true)}
                sx={{
                    display: 'flex',
                    mr: 2,
                    position: 'absolute',
                    top: '30%',
                    p: 0.5,
                    color: 'text.primary',
                    width: '24px'
                }}
                aria-label="Go back"
                size="small"
            >
                {isRtl ? (
                    <ArrowForward sx={{ fontSize: 24, fontWeight: 'bold', strokeWidth: 2 }} />
                ) : (
                    <ArrowBack sx={{ fontSize: 24, fontWeight: 'bold', strokeWidth: 2 }} />
                )}
            </IconButton>
            <Box alignItems="center" onClick={onEditClick}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            color: 'text.primary',
                            fontSize: 18,
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            letterSpacing: 0
                        }}
                    >
                        <Typography
                            sx={{
                                fontWeight: 700,
                                color: 'text.primary',
                                fontSize: 18
                            }}
                            component={'span'}
                        >
                            {from}
                        </Typography>
                        <SwapHoriz sx={{ fontSize: 18, mx: 1, color: 'text.primary' }} />
                        <Typography
                            sx={{
                                fontWeight: 700,
                                color: 'text.primary',
                                fontSize: 18
                            }}
                            component={'span'}
                        >
                            {to}
                        </Typography>
                        <Box sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>
                            <EditIcon sx={{ fontSize: 18, fontWeight: 'bold', strokeWidth: 2 }} />
                        </Box>
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography
                        component="div"
                        sx={{
                            fontSize: 15,
                            color: 'text.primary',
                            fontWeight: 500,
                            textAlign: 'center',
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer'
                        }}
                    >
                        {departDate} {!!returnDate && `- ${returnDate}`}{' '}
                        <CircleIcon sx={{ fontSize: 5, color: 'text.primary', mx: 0.5 }} /> {travelers}{' '}
                        <CircleIcon sx={{ fontSize: 5, color: 'text.primary', mx: 0.5 }} /> {t(travelClass)}
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}

export { SrpHeader }
